export const useCacheStore = defineStore('cache', () => {
  const cacheList = ref([])

  const addCache = name => {
    cacheList.value.push(name) 
  }

  const removeCache = name => {
    cacheList.value = cacheList.value.filter(n => n !== name)
  }

  const loading = ref(false)
  const changeGlobalLoading = value => { loading.value = value }

  return {
    cacheList, addCache, removeCache, loading, changeGlobalLoading,
  }
})
